import { FC } from 'react';
import { useForm, FormProvider, SubmitHandler, useFieldArray } from 'react-hook-form';
import { QueryResult } from './query';
import { Question } from 'features/questions/type';
import { Dependents as Template } from 'features/questions/templates/Dependents';
import { ButtonContainer } from 'features/questions/components/ButtonContainer';
import Button from 'jbc-front/components/Button';
import { schema, generateDefaultValues, Schema, otherFamilyObj } from './schema';
import { yupResolver } from '@hookform/resolvers/yup';
import { DeletableSection } from 'components/ui/DeletableSection';
import { FormSection } from 'components/form/FormSection';
import { FormAddButton } from 'components/form/FormAddButton';
import { ANSWER_DEPENDENTS, convertFormDataToQueryVariables } from './mutation';
import useReactRouter from 'use-react-router';
import { OtherFamily } from './OtherFamily';

// @ts-ignore
import { useMutation } from 'components/Graphql';

type SpouseProps = {
  question: Question;
  profile: Exclude<QueryResult['request']['profile'], undefined>;
  handicapImageSetting: 'none' | 'optional' | 'required';
  nonResidentAndStudyAbroadImageSetting: 'none' | 'optional' | 'required';
};

export const Form: FC<SpouseProps> = ({ question, profile, handicapImageSetting, nonResidentAndStudyAbroadImageSetting }) => {
  const { history } = useReactRouter();

  const handicapImageRequired = handicapImageSetting === 'required';
  const nonResidentAndStudyAbroadImageRequired = nonResidentAndStudyAbroadImageSetting === 'required';

  const methods = useForm({
    defaultValues: generateDefaultValues(profile.otherFamilies),
    resolver: yupResolver(schema(handicapImageRequired, nonResidentAndStudyAbroadImageRequired))
  });

  const { handleSubmit, control } = methods;
  const { fields, append, remove } = useFieldArray({
    control,
    name: 'otherFamilies'
  });

  const [update, { loading }] = useMutation(ANSWER_DEPENDENTS, {
    refetchQueries: ['clientSettings', 'questionGroups']
  });

  const onSubmit: SubmitHandler<Schema> = async (data: Schema) => {
    const variables = convertFormDataToQueryVariables(data);
    await update({ variables });

    history.push('/employee_input');
  };

  return (
    <FormProvider {...methods}>
      <Template question={question} initiallyOpen={true}>
        <FormSection>
          {fields.map((field, index) => (
            <DeletableSection key={field.id}>
              <DeletableSection.Header onDelete={() => remove(index)}>扶養親族（{index + 1}）</DeletableSection.Header>
              <DeletableSection.Body>
                <OtherFamily profile={profile} index={index} />
              </DeletableSection.Body>
            </DeletableSection>
          ))}

          <FormAddButton onClick={() => append(otherFamilyObj)}>扶養親族情報を追加</FormAddButton>
        </FormSection>

        <ButtonContainer>
          <Button primary onClick={handleSubmit(onSubmit)} disabled={loading}>
            次へ
          </Button>
        </ButtonContainer>
      </Template>
    </FormProvider>
  );
};
